import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'decimalToTimeFormat'
})
export class DecimalToTimeFormatPipe implements PipeTransform {

  transform(decimal: number): string {
    const hours = Math.floor(decimal);
    const minutes = (decimal - hours) * 60;

    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = Math.round(minutes).toString().padStart(2, '0');

    return `${hoursStr} ${minutesStr}`;
  }
}
